import React from 'react';
import './Skills.css';
import htmlIcon from '../../assets/skills/html5.png';
import cssIcon from '../../assets/skills/css3.png';
import jsIcon from '../../assets/skills/js.png';
import bootstrapIcon from '../../assets/skills/bootstrap5.png';
import gitIcon from '../../assets/skills/git.png';
import javaIcon from '../../assets/skills/java.png';
import pythonIcon from '../../assets/skills/python.png';
import csharpIcon from '../../assets/skills/csharp.png';
import gcloudIcon from '../../assets/skills/gcloud.png';
import postmanIcon from '../../assets/skills/postman.png';
import androidIcon from '../../assets/skills/android.png';
import firebaseIcon from '../../assets/skills/firebase.png';

const skillCategories = [
  {
    category: 'Frontend & UI',
    description: 'Responsive, accessible web interfaces',
    skills: [
      { name: 'JavaScript', icon: jsIcon },
      { name: 'HTML5', icon: htmlIcon },
      { name: 'CSS3', icon: cssIcon },
      { name: 'Bootstrap 5', icon: bootstrapIcon }
    ]
  },
  {
    category: 'Backend & Core',
    description: 'Object-oriented logic, APIs & data pipelines',
    skills: [
      { name: 'Java', icon: javaIcon },
      { name: 'Python', icon: pythonIcon },
      { name: 'C#', icon: csharpIcon }
    ]
  },
  {
    category: 'Cloud & Database',
    description: 'Cloud services, real-time data & authentication',
    skills: [
      { name: 'Google Cloud', icon: gcloudIcon },
      { name: 'Firebase', icon: firebaseIcon }
    ]
  },
  {
    category: 'Tools & Mobile',
    description: 'Version control, native mobile & API tooling',
    skills: [
      { name: 'Android', icon: androidIcon },
      { name: 'Git', icon: gitIcon },
      { name: 'Postman', icon: postmanIcon }
    ]
  }
];

const Skills = () => {
  return (
    <section id="skills" className="skills-section">
      <div className="section-header">
        <span className="section-tag">Capabilities</span>
        <h2 className="section-title">Technical Matrix</h2>
        <p className="section-subtitle">
          Core languages, frameworks, developer tools, and cloud platforms I use to build modern products.
        </p>
      </div>

      <div className="skills-bento-grid">
        {skillCategories.map((group, idx) => (
          <div key={idx} className="skills-group-card">
            <div className="skills-group-header">
              <h3 className="skills-group-title">{group.category}</h3>
              <p className="skills-group-desc">{group.description}</p>
            </div>

            <div className="skills-pill-grid">
              {group.skills.map((skill, sIdx) => (
                <div key={sIdx} className="skill-pill-card">
                  <div className="skill-icon-wrapper">
                    <img src={skill.icon} alt={skill.name} className="skill-pill-img" />
                  </div>
                  <span className="skill-pill-name">{skill.name}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Skills;